export const normalizeBlockId = (id: string) => id.replace(/\$$/, '');

export const inlineContentToText = (content: any): string => {
  if (!content) return '';
  if (Array.isArray(content))
    return content
      .map((c: any) => {
        if (c?.type === 'text') return c.text ?? '';
        if (c?.type === 'mention') return `@${c.props?.label ?? ''}`;
        if (Array.isArray(c?.content)) return inlineContentToText(c.content);
        return '';
      })
      .join('');
  return '';
};
